import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ButtonBase from '@material-ui/core/ButtonBase';

import { format, parse } from 'date-fns';

import { scrollbarStylesHorizontal } from '../../../../../utils/scrollbar'
import SkyImage from "../SkyImage";
import drop from '../images/drop.png';
import thermometer from '../images/thermometer.png';
import wind from '../images/wind.png';

const useStyles = makeStyles((theme) => ({
    scrollBar: {
        transform: 'translateZ(0)',
        ...scrollbarStylesHorizontal,
    },
    tile: {
        '& .MuiListItem-root': {
            padding: 0,
            paddinBottom: theme.spacing(1)
        },
        '& .MuiBox-root': {
            width: '100%'
        },
        minWidth: 90,
        height: 200,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        justifyContent: 'center',
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    image: {
        height: 17,
        marginRight: 2
    },
    actionArea: {
        "&:hover": {
            backgroundColor: '#D3D3D3'
        }
    },

}));

const flexContainer = {
    display: 'flex',
    minWidth: 'fit-content',
    margin: 5,
    justifyContent: 'space-around',
};


export default function DailyForecast({ data, handleDetailClick, forecastDayDetail }) {
    const classes = useStyles();

    const { t } = useTranslation();

    React.useEffect(() => {
        if (data) handleDetailClick(data[0].ref_time)
    }, [data]);

    const parseAEMETDate = (date) => {
        return parse(date.substring(0, 10), 'yyyy-MM-dd', new Date())
    };

    return (<>
        <List style={flexContainer} className={classes.scrollBar} >
            {data.map((day, index) => (
                <Card key={index} 
                    style={{
                        margin: 5,
                        minWidth: 200,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center"}}>
                        <ButtonBase
                            onClick={event => { index < 3 ? handleDetailClick(day.ref_time) : null }}
                            className={index < 3 ? classes.actionArea : null}
                        >
                            <Tooltip title={t('desplegar-detalle-por-hora')} arrow disableHoverListener={index >= 3}>

                                <CardContent>
                                    <List key={day.ref_time} className={classes.tile}>

                                        <ListItem>
                                            <Box display="flex" justifyContent="center" m={0.5}>
                                                <Typography>{format(parseAEMETDate(day.ref_time), 'd LLL')}</Typography>
                                            </Box>
                                        </ListItem>
                                        <ListItem>
                                            <Box display="flex" justifyContent="center" m={0.5}>
                                                <SkyImage imageHeight={60} skyState={day.detailed_status} />
                                            </Box>
                                        </ListItem>
                                        <ListItem>
                                            <Tooltip title='Temperatura min/max' aria-label='Temperatura'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={thermometer} alt='thermometer' className={classes.image} />
                                                    {` ${Math.floor(day.temp.min)}°/${Math.floor(day.temp.max)}°`}
                                                </Box>
                                            </Tooltip>
                                        </ListItem>
                                        <ListItem>
                                            <Tooltip title='Probabilidad de precipitación' aria-label='Probabilidad de precipitación'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={drop} alt='drop' className={classes.image} />{` ${Math.floor(day.precipitation_probability * 100)}%`}
                                                </Box>
                                            </Tooltip>
                                        </ListItem>
                                        <ListItem>
                                            <Tooltip title='Viento' aria-label='Viento'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={wind} alt='wind' className={classes.image} />
                                                    {` ${Math.floor(day.wnd.speed * (18 / 5))}km/h`}
                                                </Box>
                                            </Tooltip>
                                        </ListItem>
                                    </List>

                                    {data.length !== index + 1 && <Divider orientation="vertical" flexItem />}

                                </CardContent>
                            </Tooltip>
                        </ButtonBase>
                    </Card>
            ))}
        </List>
    </>

    );
}
